<template>
  <details
    v-if="isSmall || always"
    class="sample-indicator"
    :class="{
      'sample-warning': isSmall,
      'sample-severe': level === 'very-small',
    }"
  >
    <summary>
      <span v-if="!compact || isSmall">{{
        level === "very-small"
          ? l("Svært lite utvalg", "Very small sample")
          : isSmall
          ? l("Lite utvalg", "Small sample")
          : l("Datagrunnlag", "Sample size")
      }}</span>
      <span
        >n =
        {{
          count == null
            ? "—"
            : count.toLocaleString(locale === "no" ? "nb-NO" : "en-GB")
        }}</span
      ><span class="sample-info" aria-hidden="true">ⓘ</span>
    </summary>
    <p>
      {{
        l(
          "Antall registrerte vurderinger i denne beregningen, ikke nødvendigvis unike studenter. Små utvalg gjør at få resultater kan flytte prosenter og snitt mye.",
          "Recorded results in this calculation, not necessarily unique students. With small samples, a few results can substantially change percentages and averages."
        )
      }}<br />{{
        l(
          "Vi varsler under 50 vurderinger, og ekstra tydelig under 10. Dette er en visningsregel, ikke en grense for statistisk signifikans.",
          "We flag fewer than 50 results, with a stronger warning below 10. These are display rules, not statistical significance thresholds."
        )
      }}
    </p>
  </details>
</template>
<script>
import { sampleLevel } from "../utils/gradeStatistics.mjs";
export default {
  name: "SampleSizeBadge",
  props: {
    count: { type: Number, default: null },
    locale: { type: String, default: "no" },
    always: Boolean,
    compact: Boolean,
  },
  computed: {
    level() {
      return sampleLevel(this.count);
    },
    isSmall() {
      return ["small", "very-small"].includes(this.level);
    },
  },
  methods: {
    l(no, en) {
      return this.locale === "no" ? no : en;
    },
  },
};
</script>
<style scoped>
.sample-indicator {
  font-size: 10px;
  color: #62765a;
  border: 1px solid #dce5d5;
  border-radius: 6px;
  background: #f5f8ef;
}
.sample-indicator summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 7px;
  cursor: pointer;
  padding: 8px 10px;
  list-style: none;
  font-weight: 500;
}
.sample-indicator summary::-webkit-details-marker {
  display: none;
}
.sample-indicator summary > span {
  font-variant-numeric: tabular-nums;
}
.sample-indicator .sample-info {
  margin-left: auto;
}
.sample-warning {
  color: #805b21;
  border-color: #e6d3a6;
  background: #fff7e5;
}
.sample-severe {
  color: #944b2d;
  border-color: #ebc8b2;
  background: #fff0e6;
}
.sample-indicator p {
  border-top: 1px solid currentColor;
  padding: 10px;
  font-size: 11px;
  line-height: 1.8;
  font-weight: 400;
}
.sample-indicator summary:focus-visible {
  outline: 3px solid #326348;
  outline-offset: 3px;
}
</style>
